module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-es.5cf83943c4b77c2d6aef.svg";